import React, { Component } from 'react';
import FileSaver from 'file-saver';
import T from 'i18n-react';

import OperationService from '../../../services/OperationService';
import RaisedButton from "material-ui/RaisedButton";

class ExportCoda extends Component {

    constructor(props) {
        super(props)

        this.state = {
            operationList: props.operationList ? props.operationList : [],
            financingDate: props.financingDate,
            fundingDate: props.fundingDate
        };
        
        this.codaBlock = [];
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            'fundingDate': newProps.fundingDate,
            'operationList': newProps.operationList ? newProps.operationList : [], 
            'financingDate' : newProps.financingDate
        })
    }

    render() {
        return(
            <RaisedButton label={T.translate("download.coda")} secondary onClick={() => {this.getCodaBlock()}}>
            </RaisedButton>
        )
    }

    /**
     * Crée le fichier et le télécharge
     */
    saveFile() {
        let blob = new Blob([this.codaBlock], {type: "text/plain;charset=utf-8", endings: "transparent"});
        FileSaver.saveAs(blob, 'operation_' + this.state.fundingDate + '.txt', true)        
    }


     /**
     * Appel WS pour la récupération du fichier coda 
     * @param {*} date
     */
    getCodaBlock() {
        const idBlockList = this.state.operationList
            .map(operation => {
            return operation.idBlock
            })
            .filter(idBlock => idBlock !== null)

        const dataPromise = OperationService.getCodaBlock(idBlockList, this.state.financingDate)
        dataPromise.then((data) => {
            // Permet d'avoir des sauts de ligne a chaque \n
            this.codaBlock = data.fileContent.split("\\n").join("\r\n")
            this.saveFile()
        }).catch((error) => {
            //error catché dans le service
        })
    }
}

export default ExportCoda


// WEBPACK FOOTER //
// ./src/components/tableComponent/export/ExportCoda.js